import { ObjKeysCamelFormat } from "@/utils/variableName";
import { makeAutoObservable } from "mobx";
import { getAccelerateStatus } from "@/api/value-added";
import { AccelerationStatusType } from "@/types/value-added";
import { ACCELERATE_FACTOR, MAX_PENDING, TASK_LIMIT } from "@/utils/constants";
import { batchTaskPollingPool } from "@/utils/batchTask";

const defaultAccelerationStatus: AccelerationStatusType = {
  subscribed: 0,
  expireTime: null,
  subType: null,
};
class AccelerationStore {
  data: AccelerationStatusType = defaultAccelerationStatus;
  paymentModalOpen = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get isAccelerated() {
    return this.data.subscribed === 1;
  }

  get isDayVip() {
    return this.data.period === 1 || this.data.period === 2;
  }

  get isVip() {
    return this.data.subscribed === 1;
  }

  get taskLimit(): number | null {
    return this.data.subscribed === 1 ? null : TASK_LIMIT;
  }
  get maxPending(): number {
    return this.data.subscribed === 1 ? MAX_PENDING * ACCELERATE_FACTOR : MAX_PENDING;
  }
  get pendingFactor(): number {
    return this.data.subscribed === 1 ? 1.0 / ACCELERATE_FACTOR : 1;
  }

  setPaymentModalOpen = (open: boolean) => {
    this.paymentModalOpen = open;
  };

  setData(data: AccelerationStatusType) {
    this.data = data;
  }
  reset() {
    this.setData({ ...defaultAccelerationStatus });
  }

  fetchAccelerateData() {
    getAccelerateStatus()
      .then((res) => res)
      .then((res) => {
        if (res.code === 0 && res.data) {
          this.setData(ObjKeysCamelFormat(res.data));
        }
      });
  }

  afterPayment() {
    if (!this.isVip) {
      if (batchTaskPollingPool.size) {
        /** 重新获取一下状态 */
        batchTaskPollingPool.forEach((batchTaskPolling) => {
          batchTaskPolling.refresh();
        });
      }
    }
    let count = 0;
    const timer = setInterval(() => {
      if (count < 3) {
        this.fetchAccelerateData();
        count++;
      } else {
        clearInterval(timer);
      }
    }, 1500);
  }
}

export const accelerationStore = new AccelerationStore();
export default AccelerationStore;
